/*
  "Vis flere" paa webshoppens kollektionssider.

  Knappen i markup'en er et rigtigt <a> til naeste side. Uden JavaScript virker
  den som almindelig paginering, og en crawler kan foelge den. Her opsnapper vi
  klikket og haenter i stedet naeste side gennem Section Rendering API'et og
  saetter varerne ind under de eksisterende.

  To ting er vaerd at vide, hvis nogen skal rette i det her:

  1. facets.js udskifter HELE innerHTML i #ProductGridContainer, hver gang der
     filtreres. Derfor er klik-handleren bundet med delegering paa document og
     ikke paa knappen selv. En handler bundet direkte paa knappen ville doe ved
     foerste filtrering, og fejlen ville vaere lydloes.

  2. URL'en i adresselinjen roeres IKKE. Skubbede vi ?page=2 ind, ville en
     genindlaesning vise side 2 alene i stedet for de varer brugeren kan se.
     paginate.next.url baerer i forvejen de aktive filtre med sig.
*/
(function () {
  'use strict';

  var GRID = '#product-grid';
  var CONTAINER = '#ProductGridContainer';

  function sektionsId() {
    var grid = document.querySelector(GRID);
    return grid ? grid.dataset.id : null;
  }

  function medSektion(url, id) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(id);
  }

  function opdaterStatus(boks) {
    var grid = document.querySelector(GRID);
    var vist = boks.querySelector('[data-mere-vist]');
    if (grid && vist) vist.textContent = grid.querySelectorAll('.grid__item').length;
  }

  function haentMere(knap) {
    var boks = knap.closest('[data-webshop-mere]');
    var grid = document.querySelector(GRID);
    var id = sektionsId();
    if (!boks || !grid || !id) return;

    var url = knap.getAttribute('href');
    knap.classList.add('webshop-mere__knap--henter');
    knap.setAttribute('aria-busy', 'true');
    var tekst = knap.textContent;
    knap.textContent = 'Henter ...';

    fetch(medSektion(url, id))
      .then(function (svar) {
        if (!svar.ok) throw new Error('HTTP ' + svar.status);
        return svar.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nyeVarer = doc.querySelectorAll(CONTAINER + ' ' + GRID + ' .grid__item');
        if (!nyeVarer.length) throw new Error('ingen varer i svaret');

        var foerstNye = null;
        var frag = document.createDocumentFragment();
        nyeVarer.forEach(function (vare) {
          var kopi = document.importNode(vare, true);
          if (!foerstNye) foerstNye = kopi;
          frag.appendChild(kopi);
        });
        grid.appendChild(frag);

        // Knappens naeste maal staar i det svar vi lige haentede. Findes den
        // ikke, var det sidste side, og hele boksen skiftes ud uden knap.
        var nyBoks = doc.querySelector('[data-webshop-mere]');
        boks.innerHTML = nyBoks ? nyBoks.innerHTML : '';
        opdaterStatus(boks);

        // Flyt fokus til foerste nye vare, saa den der bruger tastatur eller
        // skaermlaeser ikke bliver efterladt ved en knap der forsvandt.
        if (foerstNye) {
          var maal = foerstNye.querySelector('a, button');
          if (maal) {
            maal.setAttribute('tabindex', '-1');
            maal.focus({ preventScroll: true });
          }
        }
      })
      .catch(function (fejl) {
        // Falder tilbage til almindelig sideskift frem for at efterlade
        // brugeren med en knap der ikke goer noget.
        console.error('[webshop-vis-flere]', fejl);
        knap.classList.remove('webshop-mere__knap--henter');
        knap.removeAttribute('aria-busy');
        knap.textContent = tekst;
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    var knap = e.target.closest('[data-mere-knap]');
    if (!knap) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // aabn i ny fane skal virke
    e.preventDefault();
    haentMere(knap);
  });
})();
